import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { RedirectGuard } from './guards/redirect.guard';

const routes: Routes = [
  {
    path: 'profile',
    canActivate: [AuthGuard],
    loadChildren: () => import(`./modules/profile/profile.module`).then(m => m.ProfileModule)
  },
  {
    path: 'courses',
    canActivate: [AuthGuard],
    loadChildren: () => import(`./modules/courses/courses.module`).then(m => m.CoursesModule)
  },
  {
    path: 'lessons',
    canActivate: [AuthGuard],
    loadChildren: () => import(`./modules/lessons/lessons.module`).then(m => m.LessonsModule),
  },
  {
    path: 'users',
    canLoad: [AdminGuard],
    loadChildren: () => import(`./modules/users/users.module`).then(m => m.UsersModule),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import(`./modules/dashboard/dashboard.module`).then(m => m.DashboardModule)
  },
  {
    path: 'auth',
    loadChildren: () => import(`./modules/auth/auth.module`).then(m => m.AuthModule)
  },
  {
    path: 'not-found',
    canActivate: [AuthGuard],
    component: PageNotFoundComponent
  },
  { path: '', canActivate: [RedirectGuard], component: AppComponent, pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
